import PriceCatalogLink from './PriceCatalogLink';

export default PriceCatalogLink;
